import {
    DELETE_SEGMENT_REQUEST_CALLED,
    DELETE_SEGMENTS_REQUEST_FAILED,
    DELETE_SEGMENT_REQUEST_SUCCEEDED,
    EDIT_SEGMENT, INSERT_SEGMENT,
    SET_SELECTED_SEGMENT_BY_SLUG,
} from '@domain/segments';
import { createMiddleware } from '@shared/redux';
import { analytics } from '../../analytics';
import { getSharedData } from './utils';

/**
 * Declares the event name to track dashboard segment changes.
 * @todo Refactor event name
 * https://github.com/paretogroup/analytics/issues/14
 * */
export const DASHBOARD_SEGMENT_CHANGED_EVENT = 'dashboard_tag_group_changed';
export const DASHBOARD_SEGMENT_CREATED_EVENT = 'dashboard_tag_group_created';
export const DASHBOARD_SEGMENT_EDITED_EVENT = 'dashboard_tag_group_edited';
export const DASHBOARD_SEGMENT_DELETE_REQUESTED_EVENT = 'dashboard_tag_group_delete_requested';
export const DASHBOARD_SEGMENT_DELETE_SUCCEEDED_EVENT = 'dashboard_tag_group_delete_succeeded';
export const DASHBOARD_SEGMENT_DELETE_FAILED_EVENT = 'dashboard_tag_group_delete_failed';

const trackEvent = async (eventName, state, payload = null) => {
    const shared = getSharedData(state);

    await analytics.track(eventName, {
        ...shared,
        ...payload,
    });
};

export const segmentsMiddleware = createMiddleware({
    [SET_SELECTED_SEGMENT_BY_SLUG]: async (state, { payload }) => {
        const previousGroupSlug = state?.dashboard?.tagGroups?.selectedGroup?.slug;
        const { groupSlug } = payload;

        if (previousGroupSlug === groupSlug) {
            return;
        }

        const eventPayload = {
            groupSlug,
            previousGroupSlug,
        };

        await trackEvent(
            DASHBOARD_SEGMENT_CHANGED_EVENT,
            state,
            eventPayload,
        );
    },
    [INSERT_SEGMENT]: async (state, { payload }) => {
        await trackEvent(
            DASHBOARD_SEGMENT_CREATED_EVENT,
            state,
            payload,
        );
    },
    [EDIT_SEGMENT]: async (state, { payload }) => {
        await trackEvent(
            DASHBOARD_SEGMENT_EDITED_EVENT,
            state,
            payload,
        );
    },
    [DELETE_SEGMENT_REQUEST_CALLED]: async (state, { payload }) => {
        await trackEvent(
            DASHBOARD_SEGMENT_DELETE_REQUESTED_EVENT,
            state,
            payload,
        );
    },
    [DELETE_SEGMENT_REQUEST_SUCCEEDED]: async (state) => {
        await trackEvent(
            DASHBOARD_SEGMENT_DELETE_SUCCEEDED_EVENT,
            state,
        );
    },
    [DELETE_SEGMENTS_REQUEST_FAILED]: async (state) => {
        await trackEvent(
            DASHBOARD_SEGMENT_DELETE_FAILED_EVENT,
            state,
        );
    },
}, { beforeChanges: true });
